import React from 'react';
import { interpolateReds } from 'd3';
import DoughnutPlot from '../../components/DoughnutPlot';

export default function DewPoint({ size }) {
  return (
    <DoughnutPlot
      size={size}
      dataKey="dew_point"
      maxValue={100}
      makeColors={
        value => [interpolateReds(value / 100), 'lightgrey']
      }
    />
  )
  
}


// WEBPACK FOOTER //
// ./src/plots/DewPoint/index.js